<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">شارك واربح</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">شارك واربح</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">

            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <successAlert v-if="hasSucess" :message="message" />
            <mainLoader v-if="mainLoading" />

            <template v-if="!mainLoading">

              <!-- there is already an article: show it / edit it / delete it -->
              <div v-if="row && !isEditing" class="card card-secondary card-outline mb-4 mt-4">
                <div class="card-header d-flex align-items-center">
                  <div class="card-title mb-0">المقال الحالي</div>
                  <span class="badge rounded-pill fs-6 px-3 py-2 ms-auto" :class="row.isActive ? 'bg-success' : 'bg-secondary'">
                    {{ row.isActive ? 'نشط' : 'غير نشط' }}
                  </span>
                </div>
                <div class="card-body">
                  <h5 class="mb-3">{{ row.title }}</h5>
                  <div class="rte-preview" v-html="row.content"></div>
                </div>
                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="checkAccess('shareWin_update')" class="btn btn-primary me-2" @click="startEdit()">
                        <i class="bi bi-pencil-square me-1"></i> تعديل
                      </button>
                      <button v-if="checkAccess('shareWin_delete')" class="btn btn-danger" @click="deleteRow()">
                        <i class="bi bi-trash me-1"></i> حذف وكتابة مقال جديد
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- create / edit form -->
              <div v-if="!row || isEditing" class="card card-secondary card-outline mb-4 mt-4">
                <div class="card-header">
                  <div class="card-title">{{ row ? 'تعديل المقال' : 'إضافة مقال شارك واربح' }}</div>
                </div>

                <form @submit.prevent="submitData()">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <label class="form-label">عنوان المقال:</label>
                        <input type="text" v-model="title" class="form-control" placeholder="مثال: شارك واربح">
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 mb-3">
                        <label class="form-label">محتوى المقال:</label>
                        <TextEditor v-model="content" placeholder="اكتب نص المقال هنا..." />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label class="form-label">حالة المقال:</label>
                        <select v-model="isActive" class="form-control">
                          <option :value="true">نشط</option>
                          <option :value="false">غير نشط</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="row">
                      <div class="col text-end">
                        <button v-if="row" type="button" class="btn btn-light me-2" @click="cancelEdit()">إلغاء</button>
                        <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
                        <loader v-if="formLoader" />
                      </div>
                    </div>
                  </div>
                </form>
              </div>

            </template>

          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import TextEditor from '@/components/TextEditor.vue';
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'ShareWinIndex',
  components: {
    TextEditor,
  },
  data(){
    return {
      mainLoading: true,
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      row: null,
      isEditing: false,
      title: '',
      content: '',
      isActive: true,
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.mainLoading = true;
      this.hasError = false;
      this.$http.get('/api/admin/shareWin/show').then(({data}) => {
        this.row = data.row;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    startEdit(){
      this.title = this.row.title;
      this.content = this.row.content;
      this.isActive = this.row.isActive;
      this.isEditing = true;
      this.hasError = false;
      this.hasSucess = false;
    },
    cancelEdit(){
      this.isEditing = false;
    },
    submitData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      const body = {
        title: this.title,
        content: this.content,
        isActive: this.isActive,
      };

      let api = null;
      if(this.row)
        api = this.$http.put(`/api/admin/shareWin/update/${this.row.id}`, body);
      else
        api = this.$http.post('/api/admin/shareWin/create', body);

      api.then(({data}) => {
        this.row = data.row;
        this.isEditing = false;
        this.message = 'تم الحفظ بنجاح';
        this.hasSucess = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف المقال ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });

      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/shareWin/delete/${this.row.id}`).then(() => {
          this.row = null;
          this.title = '';
          this.content = '';
          this.isActive = true;
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
  },
  created(){
    this.getRowData();
  }
}
</script>

<style scoped>
.rte-preview {
  line-height: 1.7;
}
</style>